import api from 'utils/api';
import { combineReducers } from 'redux';

import { getStore } from 'shared/stash';

export const RECEIVED_GEOGRAPHIC_STATES = 'RECEIVED_STATES';
export const FETCHING_GEOGRAPHIC_STATES = 'FETCHING_GEOGRAPHIC_STATES';

// Action creators:
function fetchingStates() {
  getStore().dispatch({ type: FETCHING_GEOGRAPHIC_STATES });
}

function receivedStates(states) {
  getStore().dispatch({ type: RECEIVED_GEOGRAPHIC_STATES, states });
}

function fetchStates() {
  const states = getStore().getState().geographic.statesCollection.items;
  if (!states) {
    fetchingStates();
    return api.get('/shared/api/states.json').then(response => {
      receivedStates(response.data);
    });
  }
  return null;
}

const actions = {
  fetchStates,
};

export { actions };

// Reducers
const initialStatesCollectionReducerState = {
  items: null,
  isFetching: false,
};

function statesCollectionReducer(state = initialStatesCollectionReducerState, action) {
  switch (action.type) {
    case FETCHING_GEOGRAPHIC_STATES:
      return Object.assign({}, state, { isFetching: true });

    case RECEIVED_GEOGRAPHIC_STATES:
      return Object.assign({}, state, { isFetching: false, items: action.states });

    default:
      return state;
  }
}

export { statesCollectionReducer, initialStatesCollectionReducerState };

const geographicReducer = combineReducers({
  statesCollection: statesCollectionReducer,
});

export { geographicReducer };
